<template>
  <li
    v-for="item in items"
    :key="item.id"
  >
    <SuggestCategoryListItem
      :slug="item.slug"
      :label="item.label"
    />
  </li>
</template>

<script setup>
import { computed } from 'vue';
import SuggestCategoryListItem from './SuggestCategoryListItem.vue';

const props = defineProps({
  menu: {
    type: Object,
    required: true,
  },
});
const items = computed(() => props.menu.menuItems
  .slice(0, 6)
  .map((menuItem) => menuItem?.child_menu.at(0) || menuItem));

</script>
